import { render, staticRenderFns } from "./landingpage.vue?vue&type=template&id=3d0be9a4&"
import script from "./landingpage.vue?vue&type=script&lang=js&"
export * from "./landingpage.vue?vue&type=script&lang=js&"
import style0 from "./landingpage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports